var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBusGlif(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 0C1.6364 0 0 0.7433 0 2.7461V7.1992V11C0 11 0 12 1 12V13C1 13 1 14 2 14C3 14 3 13 3 13V12H9V13C9 13 9 14 10 14C11 14 11 13 11 13V12C11 12 12 12 12 11V2.7461C12 0.7006 10.764 0 9.4004 0H3ZM3.25 1.25H8.75C8.8885 1.25 9 1.3615 9 1.5C9 1.6385 8.8885 1.75 8.75 1.75H3.25C3.1115 1.75 3 1.6385 3 1.5C3 1.3615 3.1115 1.25 3.25 1.25ZM2 3H10C11 3 11 3.9668 11 3.9668V6C11 6 11 7 10 7H2C1 7 1 6 1 6V4C1 4 1 3 2 3ZM2 9C2.5523 9 3 9.4477 3 10C3 10.5523 2.5523 11 2 11C1.4477 11 1 10.5523 1 10C1 9.4477 1.4477 9 2 9ZM10 9C10.5523 9 11 9.4477 11 10C11 10.5523 10.5523 11 10 11C9.4477 11 9 10.5523 9 10C9 9.4477 9.4477 9 10 9Z",
    fill: "#2B303A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusGlif);
export default __webpack_public_path__ + "static/media/bus_glif.29b02768a92ff214604a5216c738e3e3.svg";
export { ForwardRef as ReactComponent };